const banner = {
  "banner_01_title": "Define<span>®</span><br /><em>Classic</em>",
  "banner_02_title": "Define<span>®</span><br /><em>Fresh</em>",
  "banner_01_content": "Natural-toned hues that accentuate with bold charisma.",
  "banner_02_content": "Nature-inspired colours designed to enhance and brighten.",
  "banner_button_01": "Virtual Mirror",
  "banner_button_02": "Discover Define®",
}

export default banner